module.exports = __webpack_public_path__ + "34bc775d/img/print-icon.d8dbbca5.svg";